import type { BrokeragePosterItem } from '@/api/mall/trade/brokerage/poster'

/** 预览画布宽度（与人人一致） */
export const PREVIEW_WIDTH = 320
/** 建议预览最小高度（1135/2） */
export const PREVIEW_MIN_HEIGHT = 568

export const SIZE_PX = {
  avatar: { big: 75, medium: 60, small: 45 },
  qrcode: { big: 120, medium: 100, small: 80 },
  nickname: { big: 16, medium: 14, small: 12 }
} as const

export const COLORS = [
  '#ffffff',
  '#f7f8fc',
  '#f7f4ef',
  '#ffb204',
  '#fff681',
  '#fbf9c9',
  '#009845',
  '#4cc601',
  '#1d2089',
  '#61cdfc',
  '#888888',
  '#dcdcdc',
  '#a50083',
  '#b43f83',
  '#fcd6a5',
  '#000000',
  '#e50112',
  '#e30047'
]

export interface PosterTemplate {
  tempid: string
  title: string
  items: BrokeragePosterItem[]
}

export const DEFAULT_TEMPLATES: PosterTemplate[] = [
  {
    tempid: 'default1',
    title: '模板1',
    items: [
      { type: 'qrcode', size: 'big', top: 158, left: 99 },
      { type: 'nickname', size: 'small', color: '#000000', align: 'center', top: 98, left: 124 },
      { type: 'avatar', size: 'medium', style: 'circle', align: 'center', top: 30, left: 129 }
    ]
  },
  {
    tempid: 'default2',
    title: '模板2',
    items: [
      { type: 'qrcode', size: 'big', top: 400, left: 100 },
      { type: 'nickname', size: 'small', color: '#000000', top: 48, left: 110 },
      { type: 'avatar', size: 'medium', style: 'circle', top: 44, left: 36 }
    ]
  },
  {
    tempid: 'default3',
    title: '模板3',
    items: [
      { type: 'qrcode', size: 'small', top: 102, left: 210 },
      { type: 'nickname', size: 'small', color: '#000000', top: 151, left: 54 },
      { type: 'avatar', size: 'big', style: 'circle', top: 73, left: 51 }
    ]
  }
]

export function blankItems(): BrokeragePosterItem[] {
  return [
    { type: 'qrcode', size: 'big', align: 'center', top: 280, left: 99 },
    { type: 'nickname', size: 'small', color: '#000000', align: 'center', top: 125, left: 124 },
    { type: 'avatar', size: 'medium', style: 'circle', align: 'center', top: 30, left: 129 }
  ]
}

export function itemSizePx(type: string, size?: string): number {
  const s = (size || 'medium') as 'big' | 'medium' | 'small'
  if (type === 'avatar') return SIZE_PX.avatar[s] || SIZE_PX.avatar.medium
  if (type === 'qrcode') return SIZE_PX.qrcode[s] || SIZE_PX.qrcode.medium
  return 30
}

export function nicknameFontPx(size?: string): number {
  const s = (size || 'small') as 'big' | 'medium' | 'small'
  return SIZE_PX.nickname[s] || SIZE_PX.nickname.small
}
